/* eslint-disable */
import React from 'react'
import { scaleLinear } from 'd3-scale'
import { line, curveBasis } from 'd3-shape'
import { axisLeft } from 'd3-axis'

import filter from 'lodash/filter'
import * as d3Color from 'd3-color'
import { RemoveBadPitchPoints } from '../../Utilities/RemoveBadPoints'
import Color from '../../Utilities/Colors/ColorMap'
import Legend from '../../Legend/Legend'
import Tooltip from '../../Tooltip/Tooltip'
import TooltipHtml from '../../Tooltip/Html/SingleEvent'

import setTextColorWithBackground from '../../Utilities/Colors/TextColorBasedOnBackground'

export default function ReleasePoint({ settings, chartOptions = {} }) {
    const pitchData = settings.data
    const { legendType } = chartOptions

    const x = scaleLinear().range([0, settings.vizWidth]).domain([-9, 9])
    const y = scaleLinear().range([settings.vizHeight, 0]).domain([0, 9])

    function handleMouseOver(event, tip) {
        Tooltip(event, settings, tip)
    }

    function handleMouseOut(event) {
        Tooltip(event, settings)
    }

    let radiusSize = 3

    if (chartOptions.labelPitches && pitchData.length >= 1000) {
        radiusSize = 10
    } else if (chartOptions.labelPitches && pitchData.length >= 100) {
        radiusSize = 8
    } else if (chartOptions.labelPitches && pitchData.length >= 10) {
        radiusSize = 6
    } else if (chartOptions.labelPitches && pitchData.length >= 1) {
        radiusSize = 5
    }

    const path = line()
        .x((d) => x(d[0]))
        .y((d) => y(d[1]))
        .curve(curveBasis)

    const yLabels = [8, 6, 4, 2]
    const xLabels = [-6, -4, -2, 0, 2, 4, 6]
    return (
        <>
            <g id="releaseChart">
                <line
                    x1={x(-9)}
                    x2={x(9)}
                    y1={y(8)}
                    y2={y(8)}
                    stroke="#eeeeee"
                />

                {xLabels.map((label, i) => (
                    <React.Fragment key={`key_xrpLabel_${i}`}>
                        <line
                            key={`xLabelLine_${i}`}
                            x1={x(label)}
                            x2={x(label)}
                            y1={y(0)}
                            y2={y(8)}
                            stroke="#f0f0f0"
                        />
                        <text
                            key={`xLabelText_${i}`}
                            x={x(label)}
                            y={y(8.05)}
                            className="release-point-axis-label"
                        >
                            {label != 0 ? `${Math.abs(label)}ft` : null}
                        </text>
                    </React.Fragment>
                ))}
                {yLabels.map((label, i) => (
                    <React.Fragment key={`key_yrpLabel_${i}`}>
                        <line
                            key={`yLabelLine_${i}`}
                            x1={x(-9)}
                            x2={x(9)}
                            y1={y(label)}
                            y2={y(label)}
                            stroke="#f0f0f0"
                        />
                        <text
                            key={`yLabelText_${i}`}
                            x={x(-8.8)}
                            y={y(label + 0.05)}
                            className="release-point-axis-label"
                        >
                            {label}ft
                        </text>
                    </React.Fragment>
                ))}
                <path
                    d={path([
                        [-9, 0],
                        [0, 0.8],
                        [9, 0],
                    ])}
                    className="mound"
                />
                {pitchData.map((d, i) => (
                    <g
                        key={`g_rp_key_${i}`}
                        transform={`translate(${x(d.x)},${y(d.y)})`}
                        style={{ cursor: 'pointer' }}
                        onMouseOver={(event) => {
                            const html = TooltipHtml(d)
                            handleMouseOver(event, html)
                        }}
                        onMouseOut={(event) => {
                            handleMouseOut(event, d)
                        }}
                        onClick={() => {
                            if (d.game_year >= 2017) {
                                window.open(
                                    `https://baseballsavant.mlb.com/sporty-videos?playId=${d.play_id}`
                                )
                            }
                        }}
                    >
                        <circle
                            key={`rp_${i}`}
                            r={radiusSize / settings.vizScale}
                            opacity={chartOptions.opacity}
                            fill={Color(
                                chartOptions.legendType,
                                d[chartOptions.legendType]
                            )}
                            stroke="black"
                        />
                        {chartOptions.labelPitches ? (
                            <text
                                className="pitch-label"
                                key={`rp_text_key_${i}`}
                                id={`text_${i}`}
                                textAnchor="middle"
                                dy={4}
                                fill={setTextColorWithBackground(
                                    d3Color.color(
                                        Color(
                                            chartOptions.legendType,
                                            d[chartOptions.legendType]
                                        )
                                    )
                                )}
                            >
                                {i + 1}
                            </text>
                        ) : null}
                    </g>
                ))}
            </g>
            {chartOptions.legend ? (
                <Legend settings={settings} type={chartOptions.legendType} />
            ) : null}
        </>
    )
}
